import axios from "axios";

/*
 * Resolve the backend origin:
 *   • In the browser, default to same-origin (`window.location.origin`) so the
 *     deployed app always talks to its own domain - no CORS, no cookie-domain
 *     pain, works on preview AND any custom domain (crm.cescoequipment.com.au).
 *   • Respect REACT_APP_BACKEND_URL only when it's explicitly set to something
 *     different (e.g. running the frontend dev server against a remote API).
 *   • In non-browser / SSR contexts, fall back to the env var.
 */
const ENV_BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const SAME_ORIGIN = typeof window !== "undefined" ? window.location.origin : "";
const BACKEND_ORIGIN = SAME_ORIGIN || ENV_BACKEND;

const API = `${BACKEND_ORIGIN}/api`;
export const BACKEND = BACKEND_ORIGIN;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

/*
 * Suppress the React dev-mode runtime error overlay for HTTP errors. They are
 * already surfaced to call-sites via thrown promises (every reload/save uses
 * try/catch + toast). The dev overlay covering the page on every transient
 * 4xx is noise that doesn't appear in production builds anyway.
 *
 * We mark the error so the call site still sees it (axios still rejects),
 * but we tell window.onerror it's been "handled".
 */
api.interceptors.response.use(
  (r) => r,
  (err) => {
    err.__handled_in_axios__ = true;
    return Promise.reject(err);
  },
);

if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (e) => {
    if (e.reason && e.reason.__handled_in_axios__) {
      // Don't let CRA's runtime overlay show this - call sites handle it.
      e.preventDefault?.();
    }
  });
}

export default api;
export { API };

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map(e => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
